import { useQuery } from "react-query";
import { API_URL } from "../api";
import { APIError, APIResponse, get } from "../api";

export type ReferralCounts = {
  downlines: number;
  qualified: number;
  rewarded: number;
};

export type ReferralEarnings = {
  currency: string;
  paid: number;
  pending: number;
  total: number;
};

export type ReferralSummaryData = {
  referralCode: string | null;
  hasReferralAttribution: boolean;
  referredBy: {
    kind: "user" | "campaign";
    code: string;
  } | null;
  attributedAt: string | null;
  counts?: ReferralCounts;
  earnings?: ReferralEarnings;
};

export function useReferralSummary() {
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;

  return useQuery<APIResponse<ReferralSummaryData>, APIError>({
    queryKey: ["referral-summary", token],
    queryFn: () =>
      get(`${API_URL}/account/user/account/referrals/me`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    enabled: !!token,
    retry: false,
    staleTime: 1000 * 60 * 2,
  });
}
